import { render, staticRenderFns } from "./ordersIcon.vue?vue&type=template&id=5cf9bbe8&"
import script from "./ordersIcon.vue?vue&type=script&lang=js&"
export * from "./ordersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports